export default {
  OK: "OK",
  ok: "OK",
  loginFailed: "Login failed, please try again.",
  requestFailed: "Request failed, please check your internet connection.",
  invalidLogin: "Invalid Username or Password.",
  invalidPassword: "Invalid Username or Password.",
  thisFunctionExists: "This function is already exists.",
  thisFunctionNotAllowDelete: "This function is not allow to delete.",
  thisFunctionNotExists: "This function is not exists.",
  targetFunctionIdRequired: "Target Function ID is required.",
  thisPageExists: "This page is already exists.",
  thisPageNotAllowDelete: "This page is not allow to delete.",
  thisRoleExists: "This role is already exists.",
  thisRoleNotAllowDelete: "This role is not allow to delete.",
  targetRoleIdRequired: "Target Role ID is required.",
  invalidParameter: "Invalid Parameter.",
  systemError: "System unable to process your request.",
  spErrorMessage: "SP Message Error (Depend what error).",
  actionbyRequired: "Current User is required.",
  sessionTokenRequired: "Session Token is required.",
  functionIdRequired: "Function ID is required.",
  functionNameRequired: "Function name is required.",
  newFunctionNameRequired: "Function name is required.",
  pageIdRequired: "Page ID is required.",
  newPageIdRequired: "Page ID is required.",
  newPageNameRequired: "Page name is required.",
  targetPageIdRequired: "Target Page ID is required.",
  userIdRequired: "User ID is required",
  passwordRequired: "Password is required.",
  userNameRequired: "Full Name is required.",
  passwordValidation: "Password must be 6-20 characters and a combination of number(s) and letter(s).",
  pageNumRequired: "Page Number is required.",
  pageSizeRequired: "Page Size is required.",
  roleIdRequired: "Role ID is required",
  oldPasswordRequired: "Current Password is required.",
  userStatusRequired: "User Status is required.",
  newRoleIdRequired: "Role ID is required.",
  newRoleNameRequired: "Role Name is required.",
  startDateRequired: "Start Date is required.",
  endDateRequired: "End Date is required.",
  startDateIsGteEndDate: "Start Date is greater than End Date.",
  thisRoleNotExists: "This Role is not exists.",
  thisPageNotExists: "This Page is not exists.",
  thisUserExists: "This User is already exists.",
  thisUserNotExists: "This User is not exists.",
  thisUserBlackListed: "Your account has been suspended.",
  thisUserInactive: "Your account has been disabled.",
  thisUserBlocked: "Your account has been blocked.",
  thisUserNotActive: "Your account has been disabled.",
  InvalidPageFunction:"Invalid Page Function.",
  invalidUser: "Invalid User!",
  invalidToken: "Invalid Session!",
  NoUserAccessRight: "Permission Denied!",
  unableSPProcess: "System unable to process your request.",
  connection: "Connection Error",
  loginIdRequired: "Login ID is required.",
  loginNameRequired: "Login Name is required.",
  targetLoginIdRequired: "Target Login ID is required.",
  newHostIdRequired: "Host ID is required.",
  newLoginNameRequired: "Login Name is required.",
  loginDisabledRequired: "Login Disabled is required.",
  thisLoginExists: "This Login is already exists.",
  thisLoginNotExists: "This Login is not exists.",
  sourceAccountIdRequired: "Source Account ID is required.",
  targetAccountIdRequired: "Target Account ID is required.",
  authTokenRequired: "Auth token is required.",
  accountIdRequired: "Account ID is required.",
  minDepositRequired: "Minimum Deposit is required.",
  minWithdrawalRequired: "Minimum Withdrawal is required.",
  minBalanceRequired: "Minimum Balance is required.",
  invalidSourceAccountId: "Invalid Source Account ID.",
  invalidTargetAccountId: "Invalid Target Account ID.",
  subLoginIdRequired: "Sub Login ID is required.",
  invalidAccountId: "Invalid Account ID.",
  invalidSubLoginId: "Invalid Sub Login ID.",
  parentIdRequired: "Parent ID is required.",
  invalidParentId: "Invalid Parent ID.",
  newLoginIdRequired: "New Login ID is required.",
  newPasswordRequired: "New Password is required.",
  securityTagRequired: "Security Tag is required.",
  securityCodeRequired: "Security Code is required.",
  authorityOptionRequired: "Authority Option is required.",
  profileIdRequired: "Profile ID is required.",
  newStatusRequired: "New Status is required.",
  amountRequired: "Amount is required.",
  bankIdRequired: "Bank ID is required.",
  bankAccNoRequired: "Bank Account No. is required.",
  bankAccHolderRequired: "Bank Account Holder is required.",
  newBankIdRequired: "New Bank ID is required.",
  newBankAccNoRequired: "New Bank Account No. is required.",
  newBankAccHolderRequired: "New Bank Account Holder is required.",
  bankNameRequired: "Bank Name is required",
  incomingAmountThresholdRequired: "Incoming Amount Threshold is required.",
  incomingFrequencyThresholdRequired: "Incoming Frequency Threshold is required.",
  outgoingAmountThresholdRequired: "Outgoing Amount Threshold is required.",
  outgoingFrequencyThresholdRequired: "Outgoing Frequency Threshold is required.",
  accountBalanceRequired: "Account Balance is required.",
  contactPhoneRequired: "Contact Phone is required.",
  memberIdRequired: "Member ID is required.",
  referrerCodeRequired: "Referrer Code is required.",
  referrerIdRequired: "Referrer ID is required.",
  referrerRequired: "Referrer is required.",
  packageIdRequired: "Package ID is required.",
  fullNameMinThreeChar: "Full name must have at least 3 characters.",
  accountIdMinThreeChar: "Account ID must have at least 3 characters.",
  nicknameMinThreeChar: "Nickname must have at least 3 characters.",
  searchCriteriaRequired: "Search criteria is required.",
  reviewIdRequired: "Review ID is required.",
  auditByRequired: "Audit by is required.",
  accountTypeRequired: "Account type is required.",
  invalidAccountType: "Invalid account type",
  notMasterAccount: "Login account is not master account.",
  ticketIdRequired: "Ticket ID is required.",
  affiliateIdRequired: "Affiliate ID is required.",
  workingMonthRequired: "Working month is required.",
  commPackageRequired: "Commission package is required.",
  remarkRequired: "Remark is required.",
  workingDateRequired: "Working date is required.",
  couponCodeRequired: "Coupon Code is required.",
  couponNameRequired: "Coupon Name is required.",
  couponQuotaRequired: "Coupon Quota is required.",
  claimTypeRequired: "Claim Type is required.",
  minDepositRequired: "Min Deposit is required.",
  bonusRateRequired: "Bonus Rate is required.",
  rolloverRequired: "Rollover is required.",
  criteriaRequired: "Criteria is required.",
  allocatedRequired: "Allocated is required.",
  gameCodeRequired: "Game Code is required.",
  gameCountRequired: "Game Count is required.",
  capLimitAmtRequired: "Cap Limit Amount is required.",
  tacNotValidate: "TAC code not validate yet.",
  sourceMinTwoChar: "Source must have at least 2 characters.",
  mediumMinTwoChar: "Medium must have at least 2 characters.",
  campaignMinTwoChar: "Campaign must have at least 2 characters.",
  termMinTwoChar: "Term must have at least 2 characters.",
  contentMinTwoChar: "Content must have at least 2 characters.",
  searchByMemberRequired: "Search by member is required.",
  idRequired: "ID is required",
  searchByIdRequired: "Search by ID is required.",
  quantityRequired: "Quantity is required.",
  logIdStrRequired: "Log ID String is required.",
  onlyAllowRejectDeposit: "Only allow to reject deposit ticket.",
  socialPlatformRequired: "Social platform is required.",
  securityDisabledRequired: "Security disabled is required.",
  groupIdRequired: "Group ID is required.",
  groupNameRequired: "Group name is required.",
  bankAccTypeRequired: "Bank account type is required.",
  bankGroupIdRequired: "Bank group ID is required.",
  isPublicRequired: "Is public is required.",
  isDefaultRequired: "Is default is required.",
  bankModeRequired: "Bank mode is required.",
  recipientBankIdRequired: "Recipient Bank ID is required.",
  recipientBankAccNoRequired: "Recipient Bank account no. is required.",
  campaignIdRequired: "Campaign ID is required.",
  campaignNameRequired: "Campaign name is required.",
  rolloverNotRequired: "Rollover not required.",
  criteriaNotRequired: "Criteria not required.",
  maxBonusRequired: "Max bonus is required.",
  withholdBonusRequired: "Withhold bonus is required.",
  withholdAmountRequired: "Withhold amount is required.",
  maxWithdrawAmountRequired: "Max withdraw amount is required.",
  startTimeRequired: "Start time is required.",
  endTimeRequired: "End time is required.",
  mondayRequired: "Monday is required.",
  tuesdayRequired: "Tuesday is required.",
  wednesdayRequired: "Wednesday is required.",
  thursdayRequired: "Thursday is required.",
  fridayRequired: "Friday is required.",
  saturdayRequired: "Saturday is required.",
  sundayRequired: "Sunday is required.",
  providerCodeRequired: "Provider code is required.",
  packageRequired: "Package is required.",
  settingKeyRequired: "Setting key is required.",
  settingValueRequired: "Setting value is required.",
  bonusNameRequired: "Bonus name is required.",
  bonusValueRequired: "Bonus value is required.",
  baseAmountRequired: "Base amount is required.",
  bankGroupRequired: "Bank group is required.",
  promotionGroupRequired: "Promotion group is required.",
  withdrawalLimitRequired: "Withdrawal limit is required.",
  vipIdRequired: "VIP ID is required.",
  limitIdRequired: "Limit ID is required.",
  limitNameRequired: "Limit name is required.",
  dailyAmountRequired: "Daily amount is required.",
  dailyFrequencyRequired: "Daily frequency is required.",
  selfRebateRateRequired: "Self rebate rate is required.",
  downlineRebateRateRequired: "Downline rebate rate is required.",
  senderBankIdRequired: "Sender bank ID is required.",
  senderBankAccNoRequired: "Sender bank acc no. is required.",
  depositMethodRequired: "Deposit method is required.",
  depositAmountRequired: "Deposit amount is required.",
  targetBankIdRequired: "Target bank ID is required.",
  targetBankAccNoRequired: "Target bank account no. is required.",
  targetBankAccHolderRequired: "Target bank account holder is required.",
  refNoRequired: "Ref no. is required.",
  depositDateRequired: "Deposit date is required.",
  requestTypeRequired: "Request type is required.",
  resultIdRequired: "Result ID is required.",
  referralCodeRequired: "Referral code is required.",
  promotionIdRequired: "Promotion ID is required.",
  promotionNameRequired: "Promotion name is required.",
  bonusAmountRequired: "Bonus amount is required.",
  matchIdRequired: "Match ID is required.",
  homeScoreRequired: "Home score is required.",
  awayScoreRequired: "Away score is required.",
  createdByRequired: "Created by is required.",
  pinRequired: "Pin is required.",
  homeTeamRequired: "Home team is required.",
  awayTeamRequired: "Away team is required.",
  gameIdRequired: "Game ID is required.",
  contactEmailRequired: "Contact email is required.",
  rtpRequired: "RTP is required.",
  requestTooFrequent: "Request too frequent, please try again later.",
  roundIdRequired: "Round ID is required.",
  failedToGetUnfinishRound: "Failed to get unfinish round.",
  failedToCancelUnfinishRound: "Failed to cancel unfinish round.",
  failedToCreateFreeRound: "Failed to create free round.",
  failedToGetFreeRound: "Failed to get free round.",
  failedToGetFreeRoundGameList: "Failed to get free round game list.",
  exceedMaxmimumAmountAllowed: "Exceed maximum amount allowed.",
  belowMinimumAmountAllowed: "Below minimum amount allowed.",

  serverBusy: "Server is busy now. Please try again.",

  isRequired: "Please enter a {fname}.",
  isMinValue: "{fname} must have minimal of {fvalue}.",
  isMaxValue: "{fname} must be less than or equal to {fvalue}.",
  isMinLength: "{fname} must have at least {fvalue} characters.",
  isMaxLength: "{fname} must be less than or equal to {fvalue} characters.",
  isAlpha: "{fname} accept only alphabet.",
  isAlphaNum: "{fname} accept only alphanumerics.",
  isNumeric: "{fname} accept only numerics.",
  isEmail: "{fname} accept only valid email addresses.",
  isIpAddress: "{fname} accept only valid IPv4 addresses.",
  isSameAs: "{fname} must be same as {fname2}.",
  isUrl: "{fname} accept only URLs.",
  containAlphaNum: "{fname} must have at least one alphabet and one number.",
  alphaNumWithSpace: "{fname} accept only alphanumerics.",
  isDecimal: "{fname} accept only numerics.",
  isInteger: "{fname} accept only integer.",
  selectOption: "Please select a {fname}",
  notSameAs: "{fname} and {fname2} cannot be the same.",
  dateRangeAllowOneMonth: "Date range only allow select up to 1 month.",
  greaterThanZero: "{fname} must be greater than zero.",
  atLeastOneAuthority: "Must select at least one authority.",
  BLOCK: "Your account has been blocked.",
  SUSPEND: "Your account has been suspended.",
  CLOSE: "Your account has been closed.",
  atLeastOneProvider: "Must select at least one provider.",
  failedToGetResultUrl: "Failed to get result url.",
  failedToLaunchPaymentGateway: "Failed to launch payment gateway.",

  must_enable_at_least_one: "Must enable at least one option.",
  insufficient_balance: "Insufficient balance.",
  source_account_id_required: "Source Account ID is required.",
  source_account_id_not_exists: "Source Account ID not exists.",
  source_account_inactive: "Source Account is inactive.",
  target_account_id_required: "Target Account ID is required.",
  target_account_id_not_exists: "Target Account ID not exists.",
  target_account_inactive: "Target Account is inactive.",
  target_account_not_exists: "Target Account not exists",
  account_id_required: "Account ID is required.",
  account_not_exists: "Account not exists.",
  sub_login_id_required: "Sub Login ID is required.",
  login_id_required: "Login ID is required.",
  login_id_not_exists: "Login ID not exists.",
  profile_not_exists: "Profile not exists.",
  account_inactive: "Account is inactive",
  password_required: "Password is required.",
  invalid_password: "Invalid password.",
  permission_denied: "Permission denied.",
  min_deposit_required: "Minimum deposit is required.",
  min_withdrawal_required: "Minimum withdrawal is required.",
  min_balance_required: "Minimum balance is required.",
  account_not_blocked: "Account is not blocked.",
  parent_id_not_exists: "Parent ID not exists",
  parent_id_required: "Parent ID is required.",
  incorrect_parent: "Incorrect Parent",
  not_blocked_account: "Not a blocked account",
  target_profile_not_exists: "Target profile not exists",
  self_operate_required: "Self Operate is required.",
  parent_not_exists: "Parent not exists",
  account_id_exists: "Account ID exists",
  new_login_id_required: "New Login ID is required.",
  new_password_required: "New password is required.",
  security_tag_required: "Security Tag is required.",
  security_code_required: "Security Code is required.",
  secondary_account_exists: "Secondary account exists",
  new_login_id_exists: "New login ID exists",
  authority_option_required: "Authority Option is required.",
  audit_by_required: "Audit by is required.",
  bank_id_required: "Bank ID is required.",
  bank_acc_no_required: "Bank account No. is required.",
  bank_acc_holder_required: "Bank account holder is required.",
  new_bank_id_required: "New Bank ID is required.",
  new_bank_acc_no_required: "New Bank account No. is required.",
  new_bank_acc_holder_required: "New Bank account holder is required.",
  bank_name_required: "Bank name is required.",
  amount_required: "Amount is required.",
  bank_account_not_exists: "Bank account not exists.",
  member_not_exists: "Member not exists",
  member_account_inactive: "Member account is inactive",
  member_wallet_not_exists: "Member wallet not exists.",
  start_date_gt_end_date: "Start date greater than end date.",
  start_date_required: "Start date is required.",
  end_date_required: "End date is required.",
  bank_acc_type_required: "Bank account type is required.",
  incoming_amount_threshold_required: "Incoming amount threshold is required.",
  incoming_frequency_threshold_required: "Incoming frequency threshold is required.",
  outgoing_amount_threshold_required: "Outgoing amount threshold is required.",
  outgoing_frequency_threshold_required: "Outgoing frequency threshold is required.",
  account_balance_required: "Account balance is required.",
  bank_account_exists: "Bank account exists.",
  bank_member_exists: "Bank member is exists.",
  no_changes: "No changes.",
  bonus_name_required: "Bonus Name is required.",
  bonus_value_required: "Bonus Value is required.",
  criteria_required: "Criteria is required.",
  rollover_required: "Rollover is required.",
  remark_required: "Remark is required.",
  invalid_criteria: "Invalid criteria.",
  ongoing_promotion: "Ongoing promotion.",
  profile_inactive: "Profile is inactive.",
  parent_account_not_exists: "Parent account not exists.",
  parent_account_inactive: "Parent account is inactive.",
  parent_profile_not_exists: "Parent profile not exists.",
  parent_profile_inactive: "Parent profile is inactive.",
  profile_id_required: "Profile ID is required.",
  incorrect_password: "Incorrect password.",
  base_amount_required: "Base amount is required.",
  bonus_amount_required: "Bonus amount is required.",
  no_ongoing_promo: "No ongoing promotion.",
  package_id_required: "Package ID is required.",
  promo_package_not_exists: "Promotion package not exists.",
  promo_package_inactive: "Promotion package is inactive.",
  promo_package_downloaded: "Promotion package is downloaded.",
  promo_id_required: "Promo ID is required.",
  new_status_required: "New status is required.",
  invalid_security_code: "Invalid security code.",
  auth_token_required: "Auth token is required.",
  auth_status_required: "Auth status is required.",
  invalid_session: "Invalid Session.",
  session_expired: "Session Expired.",
  action_required: "Action is required.",
  invalid_account_status: "Invalid account status.",
  ticket_id_required: "Ticket ID is required.",
  ticket_not_exists: "Ticket not exists.",
  ticket_processed: "Ticket is processed.",
  min_deposit_not_met: "Minimum deposit not met.",
  invalid_promo_package: "Invalid promotion package.",
  promo_min_deposit_not_met: "Promotion minimum deposit not met.",
  claim_promo_only_once_a_day: "Promotion only allow to claim once per day.",
  first_deposit_met: "First deposit promotion criteria not met.",
  newbie_not_met: "Newbie promotion criteria not met.",
  claim_promo_only_once: "Promotion only allow to claim once.",
  multiplier_not_found: "Multiplier not found.",
  inner_catch: "Inner catch.",
  sender_bank_id_required: "Sender Bank ID is required.",
  sender_bank_acc_no_required: "Sender Bank Account No. is required.",
  sender_bank_acc_holder_required: "Sender Bank Account Holder is required.",
  min_withdrawal_not_met: "Minimum withdrawal amount not met.",
  promotion_requirement_not_met: "Promotion requirement not met.",
  invalid_promotion: "Invalid promotion.",
  fund_transfer_record_not_exists: "Fund transfer record not exists.",
  point_transfer_record_not_exists: "Point transfer record not exists.",
  working_date_required: "Working date is required.",
  contact_phone_required: "Contact phone is required.",
  vip_mode_required: "VIP mode is required.",
  invalid_vip_mode: "Invalid VIP mode.",
  level_1_requirement_required: "Level 1 requirement is required.",
  level_1_multp_required: "Level 1 multiplier is required.",
  level_2_requirement_required: "Level 2 requirement is required.",
  level_2_multp_required: "Level 2 multiplier is required.",
  level_3_requirement_required: "Level 3 requirement is required.",
  level_3_multp_required: "Level 3 multiplier is required.",
  level_4_requirement_required: "Level 4 requirement is required.",
  level_4_multp_required: "Level 4 multiplier is required.",
  level_5_requirement_required: "Level 5 requirement is required.",
  level_5_multp_required: "Level 5 multiplier is required.",
  level_6_requirement_required: "Level 6 requirement is required.",
  level_6_multp_required: "Level 6 multiplier is required.",
  level_7_requirement_required: "Level 7 requirement is required.",
  level_7_multp_required: "Level 7 multiplier is required.",
  already_setup: "Already setup.",
  vip_not_exists: "VIP not exists.",
  ibank_deposit: "Permission Denied.",
  sub_profile_inactive: "Sub Profile Inactive",
  referrer_code_required: "Referrer Code is required.",
  referrer_not_exists: "Referrer not exists.",
  min_balance_not_met: "Minimum Balance not met.",
  search_criteria_required: "Search criteria is required.",
  review_id_required: "Review ID is required.",
  bank_account_inactive: "Bank Account is inactive.",
  pending_result_in_game: "Pending result in game.",
  comm_package_required: "Commission package is required.",
  comm_package_not_exists: "Commission package not exists.",
  inactive_comm_package: "Commission package is inactive.",
  tac_not_validate: "TAC code not validate yet.",
  invalid_amount: "Invalid amount.",
  affiliate_id_required: "Affiliate ID is required.",
  member_id_required: "Member ID is required.",
  coupon_code_required: "Coupon Code is required.",
  coupon_name_required: "Coupon Name is required.",
  coupon_quota_required: "Coupon Quota is required.",
  coupon_code_unavailable: "Coupon Quota is unavailable.",
  coupon_exists: "Coupon exists.",
  allocated_required: "Allocated is required.",
  claim_type_required: "Claim Type is required.",
  bonus_rate_required: "Bonus Rate is required.",
  referrer_required : "Referrer is required.",
  id_required: "ID is required.",
  invalid_contact_email: "Invalid contact email.",
  log_id_required: "Log Id is required.",
  log_not_exists: "Log not exists.",
  account_exists: "Account exists.",
  social_platform_required: "Social platform is required.",
  sub_account_exists: "Sub account exists.",
  group_id_required: "Group ID is required.",
  bank_not_exists: "Bank not exists.",
  bank_group_not_exists: "Bank group not exists.",
  bank_account_group_exists: "Bank acccount group not exists.",
  is_public_required: "Is public is required.",
  group_name_required: "Group name is required.",
  is_default_required: "Is default is required.",
  bank_group_exists: "Bank group exists.",
  bank_member_not_exists: "Bank member not exists.",
  bank_inactive: "Bank is inactive.",
  banking_mode_required: "Banking mode is required.",
  bank_setting_not_exists: "Bank setting not exists.",
  working_month_required: "Working month is required.",
  recipient_bank_id_required: "Recipient Bank ID is required.",
  recipient_bank_acc_no_required: "Recipient Bank Account No. is required.",
  recipient_bank_acc_holder_required: "Recipient Bank Account Holder is required.",
  provider_code_required: "Provider code is required.",
  package_required: "Package is required.",
  bet_limit_not_exists: "Bet limit not exists.",
  withhold_bonus_required: "Withhold bonus is required.",
  withhold_amount_required: "Withhold amount is required.",
  max_withdraw_amount_required: "Maximum withdraw amount is required.",
  campaign_id_required: "Campaign ID is required.",
  campaign_name_required: "Campaign name is required.",
  campaign_id_exists: "Campaign ID exists.",
  campaign_details_required: "Campaign details is required.",
  promotion_not_exists: "Promotion not exists.",
  rollover_and_criteria_not_required: "Rollover and criteria are not required.",
  campaign_id_not_exists: "Campaign ID not exists.",
  max_bonus_required: "Maximum bonus is required.",
  start_time_gte_end_time: "Start time greater or equal to end time.",
  monday_required: "Monday is required.",
  tuesday_required: "Tuesday is required.",
  wednesday_required: "Wednesday is required.",
  thursday_required: "Thursday is required.",
  friday_required: "Friday is required.",
  saturday_required: "Saturday is required.",
  sunday_required: "Sunday is required.",
  coupon_code_exists: "Coupon code exists.",
  invalid_claim_type: "Invalid claim type.",
  invalid_working_month: "Invalid working month.",
  invalid_date_range: "Invalid date range.",
  result_id_required: "Result ID is required.",
  setting_key_required: "Setting key is required.",
  setting_value_required: "Setting value is required.",
  contact_phone_exists: "Contact phone exists.",
  bank_group_required: "Bank group is required.",
  promotion_group_required: "Promotion group is required.",
  withdrawal_limit_required: "Withdrawal limit is required.",
  withdrawal_limit_not_exists: "Withdrawal limit not exists.",
  vip_id_required: "VIP ID is required.",
  promotion_id_required: "Promotion ID is required.",
  promotion_name_required: "Promotion name is required.",
  promotion_exists: "Promotion exists.",
  promotion_group_exists: "Promotion group exists.",
  promotion_group_not_exists: "Promotion group not exists.",
  setting_not_set: "Setting not set.",
  start_date_gte_end_date: "Start date greater than or equal to end date.",
  referral_code_required: "Referral code is required.",
  security_disabled_required: "Security disabled is required.",
  deposit_amount_required: "Deposit amount is required.",
  target_bank_id_required: "Target bank ID is required.",
  target_bank_acc_no_required: "Target bank account No. is required.",
  target_bank_acc_holder_required: "Target bank account holder is required.",
  ref_no_required: "Ref no. is required.",
  deposit_date_required: "Deposit date is required.",
  deposit_method_required: "Deposit method is required.",
  client_ip_required: "Client IP is required.",
  promotion_not_available: "Promotion not available.",
  coupon_not_available: "Coupon not available.",
  request_type_required: "Request type is required.",
  self_rebate_rate_required: "Self rebate rate is required.",
  downline_rebate_rate_required: "Downline rebate rate is required.",
  vip_provider_not_exists: "VIP provider not exists.",
  limit_name_required: "Limit name is required.",
  daily_amount_required: "Daily amount is required.",
  daily_frequency_required: "Daily frequency is required.",
  limit_id_required: "Limit ID is required.",
  bank_account_required: "Bank account is required.",
  bank_account_group_not_exists: "Bank account group not exists.",
  rollover_and_criteria_required: "Rollover and criteria required.",
  start_time_required: "Start time is required.",
  member_details_required: "Member detail is required.",
  sub_account_not_exists: "Sub account not exists.",
  promotion_group_norm_exists: "Promotion group norm exists.",
  promotion_group_norm_not_exists: "Promotion group norm not exists.",
  withdrawal_limit_exists: "Withdrawal limit exists.",
  Match_not_yet_closed: "Match not yet closed.",
  Match_not_exists: "Match not exists.",
  Match_already_entered_result: "Match already entered result.",
  Insert_score_failed: "Insert score failed.",
  Insert_Failed_Log: "Insert failed log.",
  Invalid_Pin: "Invalid pin.",
  This_match_is_not_allowed_to_update: "This match is not allowed to update.",
  Update_Failed_Log: "Update failed log.",
  Update_Failed_Match: "Update failed match.",
  Update_Failed_Bet: "Update failed bet.",
  success: "Success",
  Team_Not_Exists: "Team not exists.",
  Match_Not_Allowed_to_Update: "Match not allowed to update.",
  Update_Failed: "Update faield.",
  game_id_required: "Game ID is required.",
  provider_code_not_exists: "Provider Code not exists.",
  contact_email_exists: "Contact email exists.",
  contact_email_required: "Contact email is required.",
  rtp_required: "RTP is required.",
  redeposited_ticket: "Ticket has been redeposited.",
}